export default function PageHeader({ title, subtitle, kicker, actions }) {
  return (
    <div className="flex items-start justify-between mb-8 gap-4 flex-wrap">
      <div>
        {kicker && <div className="label-uppercase mb-2 !text-brand-accent" data-testid="page-kicker">{kicker}</div>}
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight text-ink" data-testid="page-title">
          {title}
        </h1>
        {subtitle && <p className="mt-2 text-slate-600 max-w-2xl text-sm sm:text-base">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-2 items-center">{actions}</div>}
    </div>
  );
}
